(function () {
  let container = document.getElementById('snow-container');
  if (!container) return;
  let canvas = document.getElementById('snow-canvas');
  let ctx = canvas.getContext('2d');

  let flakes = [];
  let running = false;
  let rafId = null;
  let last = 0;
  let width = 0;
  let height = 0;
  let dpr = 1;
  let reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function size() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    width = container.clientWidth;
    height = container.clientHeight;
    canvas.width = Math.max(1, Math.floor(width * dpr));
    canvas.height = Math.max(1, Math.floor(height * dpr));
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.scale(dpr, dpr);
  }

  function makeFlake() {
    let r = 0.8 + Math.random() * 1.8;
    return {
      x: Math.random() * width,
      y: Math.random() * height,
      r: r,
      vy: 0.25 + Math.random() * 0.80,
      ax: 0.15 + Math.random() * 0.4,
      freq: 0.6 + Math.random() * 0.8,
      phase: Math.random() * Math.PI * 2,
      rot: Math.random() * Math.PI * 2,
      rotSpeed: (Math.random() * 0.6 - 0.3)
    };
  }

  function createFlakes() {
    let area = width * height;
    let target = Math.min(400, Math.round(area / 9000));
    let existing = flakes.length;
    if (target > existing) {
      for (let i = existing; i < target; i++) flakes.push(makeFlake());
    } else if (target < existing) {
      flakes.length = target;
    }
  }

  function drawSnowflake(ctx, r, angle) {
    let arms = 6;
    let len = r * 3;
    let branchLen = len * 0.3;
    ctx.save();
    ctx.rotate(angle);
    ctx.beginPath();
    for (let i = 0; i < arms; i++) {
      let a = (Math.PI * 2 / arms) * i;
      let cx = Math.cos(a), sy = Math.sin(a);
      ctx.moveTo(0, 0);
      ctx.lineTo(cx * len, sy * len);

      let baseX = cx * (len * 0.6);
      let baseY = sy * (len * 0.6);
      let b1 = a + Math.PI / 6;
      let b2 = a - Math.PI / 6;
      ctx.moveTo(baseX, baseY);
      ctx.lineTo(baseX + Math.cos(b1) * branchLen, baseY + Math.sin(b1) * branchLen);
      ctx.moveTo(baseX, baseY);
      ctx.lineTo(baseX + Math.cos(b2) * branchLen, baseY + Math.sin(b2) * branchLen);
    }
    ctx.stroke();
    ctx.restore();
  }

  function step(ts) {
    if (!running) return;
    let time = ts * 0.001;
    let dt = Math.min(0.033, (ts - last) * 0.001 || 0.016);
    last = ts;

    ctx.clearRect(0, 0, width, height);
    ctx.strokeStyle = 'rgba(130, 170, 230, 0.95)';
    ctx.lineWidth = 1;
    ctx.lineCap = 'round';

    for (let i = 0; i < flakes.length; i++) {
      let f = flakes[i];
      f.y += 50 * f.vy * dt;
      f.x += Math.sin(time * f.freq + f.phase) * (10 * f.ax) * dt;
      f.rot += f.rotSpeed * dt;

      if (f.y > height + 5) {
        f.y = -5;
        f.x = Math.random() * width;
      } else if (f.x < -5) f.x = width + 5;
      else if (f.x > width + 5) f.x = -5;

      ctx.save();
      ctx.translate(f.x, f.y);
      drawSnowflake(ctx, f.r, f.rot);
      ctx.restore();
    }

    rafId = requestAnimationFrame(step);
  }

  function start() {
    if (running || reduce.matches) return;
    running = true;
    last = performance.now();
    rafId = requestAnimationFrame(step);
  }

  function stop() {
    running = false;
    if (rafId) cancelAnimationFrame(rafId);
  }

  size();
  createFlakes();
  if (!reduce.matches && !document.hidden) start();

  let resizeId = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeId);
    resizeId = setTimeout(function () {
      let wasRunning = running;
      stop();
      size();
      createFlakes();
      if (wasRunning && !reduce.matches && !document.hidden) start();
    }, 150);
  }, { passive: true });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop();
    else if (!reduce.matches) start();
  });
})();
